import { action } from 'mobx'
import { StoreExt } from 'util/reactExt'

export type IKey = number | string
/**
 * @todo
 * @description Mobx 状态类重构
 * 使用模板方法和策略模式等设计模式，提高代码的扩展性、可维护性
 */
export default abstract class BaseStore extends StoreExt {
  protected hook = true
  public changeHook(flag: boolean): void {
    this.hook = flag
  }

  @action
  public getEntityList = async (namespace, param, extra?) => {
    return this.getList(namespace, param, extra)
  }

  @action
  public addEntity = async (namespace, entity, opt?) => {
    await this.add(namespace, entity)
    if (this.hook) {
      return this.getEntityList(
        namespace,
        opt ? opt.param : {},
        opt ? opt.extra : {},
      )
    }
  }

  @action
  public updateEntity = async (namespace, id: IKey, entity, opt) => {
    await this.update(namespace, id, entity, opt ? opt.extra : {})
    if (this.hook) {
      return this.getEntityList(namespace, opt ? opt.param : {})
    }
  }

  @action
  public removeEntity = async (namespace, id: IKey, opt?) => {
    await this.remove(namespace, id)
    if (this.hook) {
      return this.getEntityList(
        namespace,
        opt ? opt.param : {},
        opt ? opt.extra : {},
      )
    }
  }

  protected abstract async getList(namespace, param, extra): Promise<any>
  protected abstract async add(
    namespace: string,
    entity: any,
    extra?,
  ): Promise<any>
  protected abstract async update(
    namespace: string,
    id: IKey,
    entity: any,
    extra?,
  ): Promise<any>
  protected abstract async remove(
    namespace: string,
    id: IKey,
    extra?,
  ): Promise<any>
}

/*
const getDataListStrategies = self => {
  return {
    checkTemplate: async (param, extra) => {
      try {
        const res = await self.api.level.getCheckTemplate(param, {showMsg: false})
        self.setCheckTemplate(res)
        if (!self.currentCheck) {
          self.setCurrentCheck(res.checks.data[0], 0)
        }
      } catch (err) {
        self.setCheckTemplate({
          id: 0,
          checks: { meta: {}, data: [] },
          check_groups: []
        })

        return Promise.reject(err)
      }
    }
  }
}

class LevelStore extends BaseStore {
  @observable
  checkTemplate = {
    id: 0,
    checks: { meta: {}, data: [] },
    check_groups: []
  } // 关卡模板

  protected async getList(namespace, param, extra?): Promise<any> {
    getDataListStrategies(this)[namespace](param, extra)
  }
  protected async add(namespace: string, entity: any) {

  }

  protected async update(namespace: string, entity: any): Promise<any> {

  }

  protected async remove(id: number | string, namespace?: string): Promise<any> {

  }
}

const levelStore = new LevelStore()
// levelStore.changeHook(false)
levelStore.getEntityList('checkTemplate', {lesson_id: 1, type: 'xxx'}, 'add')
*/
